/* Bonbon-samensteller: een smalle balk onderin beeld die tijdens het kiezen laat zien
   hoeveel bonbons er al in de doos zitten (stap 48, oktober 2026).
   Leest de teller van de sectie zelf (#total-selected en #box-limit) en verandert
   niets aan de samensteller. Telefoon: weg zodra de doos vol is (dan komt de vaste
   koopbalk). Breed scherm: bij een volle doos een knop naar het afronden.
   De balk verschijnt pas na de eerste gekozen bonbon. */
(function () {
  var systeem = document.getElementById('bonbon-order-system');
  var teller = document.getElementById('total-selected');
  var limietEl = document.getElementById('box-limit');
  var lijst = document.getElementById('bonbon-list');
  if (!systeem || !teller || !limietEl || !lijst) return;
  if (!('IntersectionObserver' in window)) return;
  var limietDeel = document.getElementById('counter-limit-part');
  if (limietDeel && limietDeel.hidden) return; /* zakje: geen vast aantal */

  var mobiel = window.matchMedia('(max-width: 768px)');
  var balk = document.createElement('div');
  balk.className = 'sijl-kiesbalk';
  balk.setAttribute('aria-hidden', 'true');
  balk.innerHTML =
    '<div class="sijl-kiesbalk__rij">' +
      '<p class="sijl-kiesbalk__tekst"><strong class="sijl-kiesbalk__aantal"></strong> <span class="sijl-kiesbalk__rest"></span></p>' +
      '<button type="button" class="sijl-kiesbalk__knop" tabindex="-1"></button>' +
    '</div>' +
    '<div class="sijl-kiesbalk__streep"><span class="sijl-kiesbalk__vulling"></span></div>';
  document.body.appendChild(balk);

  var aantalEl = balk.querySelector('.sijl-kiesbalk__aantal');
  var restEl = balk.querySelector('.sijl-kiesbalk__rest');
  var knop = balk.querySelector('.sijl-kiesbalk__knop');
  var vulling = balk.querySelector('.sijl-kiesbalk__vulling');
  var lijstInBeeld = false;
  var afrondenInBeeld = false;
  var vol = false;

  function getal(el) {
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function afrondblok() {
    return systeem.querySelector('.js-ui-assembler-wrapper') || document.getElementById('sijl-main-atc');
  }

  function plaats() {
    if (mobiel.matches) {
      balk.style.left = '';
      balk.style.width = '';
      return;
    }
    var r = systeem.getBoundingClientRect();
    balk.style.left = Math.round(r.left) + 'px';
    balk.style.width = Math.round(r.width) + 'px';
  }

  function bijwerken() {
    var n = getal(teller);
    var max = getal(limietEl);
    if (!max) return;
    vol = n >= max;
    aantalEl.textContent = n + ' van ' + max + ' gekozen';
    restEl.textContent = vol ? '· je doos is vol' : '· nog ' + (max - n);
    knop.textContent = vol ? 'Afronden' : 'Vul de rest aan';
    vulling.style.width = Math.min(100, Math.round((n / max) * 100)) + '%';
    var aan = n > 0 && lijstInBeeld && !afrondenInBeeld && !(vol && mobiel.matches);
    balk.classList.toggle('is-zichtbaar', aan);
  }

  knop.addEventListener('click', function () {
    if (vol) {
      var doel = afrondblok();
      if (doel) doel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var vulaan = systeem.querySelector('.js-surprise-trigger');
    if (vulaan) vulaan.click();
  });

  new IntersectionObserver(function (items) {
    lijstInBeeld = items[0].isIntersecting;
    bijwerken();
  }).observe(lijst);

  var blok = afrondblok();
  if (blok) {
    new IntersectionObserver(function (items) {
      afrondenInBeeld = items[0].isIntersecting;
      bijwerken();
    }, { rootMargin: '0px 0px -80px 0px' }).observe(blok);
  }

  new MutationObserver(bijwerken).observe(teller, { childList: true, characterData: true, subtree: true });
  window.addEventListener('resize', function () { plaats(); bijwerken(); });
  plaats();
  bijwerken();
})();
